import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import styled from 'styled-components';
import {useSelector} from "react-redux";

function UserDetailModal(props) {
  const { close, open, data, className } = props;
  const { platform } = useSelector((state) => state);

  if (open)
    return (
      <Dialog title="Detalles del estudiante" onClose={close}>
        <div style={{ margin: '20px 70px' }} className={className}>
          <p className="mc-name">Detalles del estudiante</p>
          <div className="">
            <p className="mc-name">Nombre:</p>
            <p className="mc-text">{data.names}</p>
            <p className="mc-name">Apellidos:</p>
            <p className="mc-text">{data.lastNames}</p>
            <p className="mc-name">Matricula:</p>
            <p className="mc-text">{data.scholarID}</p>
            <p className="mc-name">Correo electrónico:</p>
            <p className="mc-text">{data.email}</p>
            <p className="mc-name">Pregunta de validación:</p>
            <p className="mc-text">{platform.formQuestion}</p>
            <p className="mc-name">Respuesta:</p>
            <p className="mc-text">{data.formQuestion}</p>
          </div>
        </div>
      </Dialog>
    );

  return null;
}

export default styled(UserDetailModal)`
  .mc-name {
    font-size: 1.7rem;
    width: 100%;
    text-align: start;
    font-weight: 700;
  }
  .mc-text {
    font-size: 1.5rem;
    width: 95%;
    text-align: start;
    margin-left: 15px;
    font-weight: 500;
  }
`;
